// source: all.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.income.Account', null, global);
goog.exportSymbol('proto.income.Amount', null, global);
goog.exportSymbol('proto.income.BankCode', null, global);
goog.exportSymbol('proto.income.CurrencyISO4217', null, global);
goog.exportSymbol('proto.income.Decimal', null, global);
goog.exportSymbol('proto.income.Details', null, global);
goog.exportSymbol('proto.income.DownloadIncomeDetailReportRequest', null, global);
goog.exportSymbol('proto.income.DownloadIncomeDetailReportResponse', null, global);
goog.exportSymbol('proto.income.FileFormat', null, global);
goog.exportSymbol('proto.income.Income', null, global);
goog.exportSymbol('proto.income.IncomeDetails', null, global);
goog.exportSymbol('proto.income.IncomeOverview', null, global);
goog.exportSymbol('proto.income.IncomeResponse', null, global);
goog.exportSymbol('proto.income.IncomeStatus', null, global);
goog.exportSymbol('proto.income.Monthly', null, global);
goog.exportSymbol('proto.income.NonIncomeDetails', null, global);
goog.exportSymbol('proto.income.NonIncomeOverview', null, global);
goog.exportSymbol('proto.income.OrderBy', null, global);
goog.exportSymbol('proto.income.Overview', null, global);
goog.exportSymbol('proto.income.RetrieveIncomeDetailRequest', null, global);
goog.exportSymbol('proto.income.RetrieveIncomeDetailResponse', null, global);
goog.exportSymbol('proto.income.RetrieveIncomeListRequest', null, global);
goog.exportSymbol('proto.income.RetrieveIncomeListResponse', null, global);
goog.exportSymbol('proto.income.Transaction', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Overview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Overview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Overview.displayName = 'proto.income.Overview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Transaction.displayName = 'proto.income.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Details = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.Details.repeatedFields_, null);
};
goog.inherits(proto.income.Details, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Details.displayName = 'proto.income.Details';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Monthly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Monthly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Monthly.displayName = 'proto.income.Monthly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.IncomeDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.IncomeDetails.repeatedFields_, null);
};
goog.inherits(proto.income.IncomeDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.IncomeDetails.displayName = 'proto.income.IncomeDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.IncomeOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.IncomeOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.IncomeOverview.displayName = 'proto.income.IncomeOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.NonIncomeDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.NonIncomeDetails.repeatedFields_, null);
};
goog.inherits(proto.income.NonIncomeDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.NonIncomeDetails.displayName = 'proto.income.NonIncomeDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.NonIncomeOverview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.NonIncomeOverview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.NonIncomeOverview.displayName = 'proto.income.NonIncomeOverview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Account.displayName = 'proto.income.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Income = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.Income.repeatedFields_, null);
};
goog.inherits(proto.income.Income, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Income.displayName = 'proto.income.Income';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.IncomeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.IncomeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.IncomeResponse.displayName = 'proto.income.IncomeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.DownloadIncomeDetailReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.DownloadIncomeDetailReportRequest.repeatedFields_, null);
};
goog.inherits(proto.income.DownloadIncomeDetailReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.DownloadIncomeDetailReportRequest.displayName = 'proto.income.DownloadIncomeDetailReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.DownloadIncomeDetailReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.DownloadIncomeDetailReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.DownloadIncomeDetailReportResponse.displayName = 'proto.income.DownloadIncomeDetailReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.RetrieveIncomeListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.RetrieveIncomeListRequest.repeatedFields_, null);
};
goog.inherits(proto.income.RetrieveIncomeListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.RetrieveIncomeListRequest.displayName = 'proto.income.RetrieveIncomeListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.RetrieveIncomeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.RetrieveIncomeListResponse.repeatedFields_, null);
};
goog.inherits(proto.income.RetrieveIncomeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.RetrieveIncomeListResponse.displayName = 'proto.income.RetrieveIncomeListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.RetrieveIncomeDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.RetrieveIncomeDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.RetrieveIncomeDetailRequest.displayName = 'proto.income.RetrieveIncomeDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.RetrieveIncomeDetailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.income.RetrieveIncomeDetailResponse.repeatedFields_, null);
};
goog.inherits(proto.income.RetrieveIncomeDetailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.RetrieveIncomeDetailResponse.displayName = 'proto.income.RetrieveIncomeDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Decimal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Decimal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Decimal.displayName = 'proto.income.Decimal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.income.Amount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.income.Amount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.income.Amount.displayName = 'proto.income.Amount';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Overview.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Overview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Overview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Overview.toObject = function(includeInstance, msg) {
  var f, obj = {
    countofdays: jspb.Message.getFieldWithDefault(msg, 1, 0),
    countofwholemonths: jspb.Message.getFieldWithDefault(msg, 2, 0),
    monthswithincome: jspb.Message.getFieldWithDefault(msg, 3, 0),
    confidence: jspb.Message.getFieldWithDefault(msg, 4, ""),
    countofmonths: jspb.Message.getFieldWithDefault(msg, 5, 0),
    persona: jspb.Message.getFieldWithDefault(msg, 6, ""),
    income: (f = msg.getIncome()) && proto.income.IncomeOverview.toObject(includeInstance, f),
    nonincome: (f = msg.getNonincome()) && proto.income.NonIncomeOverview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Overview}
 */
proto.income.Overview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Overview;
  return proto.income.Overview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Overview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Overview}
 */
proto.income.Overview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountofdays(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountofwholemonths(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthswithincome(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidence(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCountofmonths(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersona(value);
      break;
    case 7:
      var value = new proto.income.IncomeOverview;
      reader.readMessage(value,proto.income.IncomeOverview.deserializeBinaryFromReader);
      msg.setIncome(value);
      break;
    case 8:
      var value = new proto.income.NonIncomeOverview;
      reader.readMessage(value,proto.income.NonIncomeOverview.deserializeBinaryFromReader);
      msg.setNonincome(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Overview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Overview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Overview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Overview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountofdays();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCountofwholemonths();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMonthswithincome();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCountofmonths();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPersona();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIncome();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.income.IncomeOverview.serializeBinaryToWriter
    );
  }
  f = message.getNonincome();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.income.NonIncomeOverview.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 CountOfDays = 1;
 * @return {number}
 */
proto.income.Overview.prototype.getCountofdays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setCountofdays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 CountOfWholeMonths = 2;
 * @return {number}
 */
proto.income.Overview.prototype.getCountofwholemonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setCountofwholemonths = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 MonthsWithIncome = 3;
 * @return {number}
 */
proto.income.Overview.prototype.getMonthswithincome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setMonthswithincome = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Confidence = 4;
 * @return {string}
 */
proto.income.Overview.prototype.getConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 CountOfMonths = 5;
 * @return {number}
 */
proto.income.Overview.prototype.getCountofmonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setCountofmonths = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Persona = 6;
 * @return {string}
 */
proto.income.Overview.prototype.getPersona = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.setPersona = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional IncomeOverview Income = 7;
 * @return {?proto.income.IncomeOverview}
 */
proto.income.Overview.prototype.getIncome = function() {
  return /** @type{?proto.income.IncomeOverview} */ (
    jspb.Message.getWrapperField(this, proto.income.IncomeOverview, 7));
};


/**
 * @param {?proto.income.IncomeOverview|undefined} value
 * @return {!proto.income.Overview} returns this
*/
proto.income.Overview.prototype.setIncome = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.clearIncome = function() {
  return this.setIncome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Overview.prototype.hasIncome = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional NonIncomeOverview NonIncome = 8;
 * @return {?proto.income.NonIncomeOverview}
 */
proto.income.Overview.prototype.getNonincome = function() {
  return /** @type{?proto.income.NonIncomeOverview} */ (
    jspb.Message.getWrapperField(this, proto.income.NonIncomeOverview, 8));
};


/**
 * @param {?proto.income.NonIncomeOverview|undefined} value
 * @return {!proto.income.Overview} returns this
*/
proto.income.Overview.prototype.setNonincome = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Overview} returns this
 */
proto.income.Overview.prototype.clearNonincome = function() {
  return this.setNonincome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Overview.prototype.hasNonincome = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 2, ""),
    confidence: jspb.Message.getFieldWithDefault(msg, 3, ""),
    amount: (f = msg.getAmount()) && proto.income.Amount.toObject(includeInstance, f),
    descriptor: jspb.Message.getFieldWithDefault(msg, 5, ""),
    category: jspb.Message.getFieldWithDefault(msg, 6, ""),
    transactionhash: jspb.Message.getFieldWithDefault(msg, 7, ""),
    transactionid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Transaction}
 */
proto.income.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Transaction;
  return proto.income.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Transaction}
 */
proto.income.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidence(value);
      break;
    case 4:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionhash(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConfidence();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getDescriptor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTransactionhash();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp Date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.income.Transaction.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.income.Transaction} returns this
*/
proto.income.Transaction.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Transaction.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Type = 2;
 * @return {string}
 */
proto.income.Transaction.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Confidence = 3;
 * @return {string}
 */
proto.income.Transaction.prototype.getConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Amount Amount = 4;
 * @return {?proto.income.Amount}
 */
proto.income.Transaction.prototype.getAmount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 4));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Transaction} returns this
*/
proto.income.Transaction.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Transaction.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string Descriptor = 5;
 * @return {string}
 */
proto.income.Transaction.prototype.getDescriptor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setDescriptor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Category = 6;
 * @return {string}
 */
proto.income.Transaction.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string TransactionHash = 7;
 * @return {string}
 */
proto.income.Transaction.prototype.getTransactionhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setTransactionhash = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TransactionID = 8;
 * @return {string}
 */
proto.income.Transaction.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Transaction} returns this
 */
proto.income.Transaction.prototype.setTransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.Details.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Details.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Details.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Details} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Details.toObject = function(includeInstance, msg) {
  var f, obj = {
    year: jspb.Message.getFieldWithDefault(msg, 1, ""),
    month: jspb.Message.getFieldWithDefault(msg, 2, ""),
    iswholemonth: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    totalamount: (f = msg.getTotalamount()) && proto.income.Amount.toObject(includeInstance, f),
    incomecount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.income.Transaction.toObject, includeInstance),
    income: (f = msg.getIncome()) && proto.income.IncomeDetails.toObject(includeInstance, f),
    nonincome: (f = msg.getNonincome()) && proto.income.NonIncomeDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Details}
 */
proto.income.Details.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Details;
  return proto.income.Details.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Details} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Details}
 */
proto.income.Details.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setYear(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonth(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIswholemonth(value);
      break;
    case 4:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setTotalamount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIncomecount(value);
      break;
    case 6:
      var value = new proto.income.Transaction;
      reader.readMessage(value,proto.income.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 7:
      var value = new proto.income.IncomeDetails;
      reader.readMessage(value,proto.income.IncomeDetails.deserializeBinaryFromReader);
      msg.setIncome(value);
      break;
    case 8:
      var value = new proto.income.NonIncomeDetails;
      reader.readMessage(value,proto.income.NonIncomeDetails.deserializeBinaryFromReader);
      msg.setNonincome(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Details.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Details.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Details} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Details.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYear();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMonth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIswholemonth();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTotalamount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getIncomecount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.income.Transaction.serializeBinaryToWriter
    );
  }
  f = message.getIncome();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.income.IncomeDetails.serializeBinaryToWriter
    );
  }
  f = message.getNonincome();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.income.NonIncomeDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Year = 1;
 * @return {string}
 */
proto.income.Details.prototype.getYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.setYear = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Month = 2;
 * @return {string}
 */
proto.income.Details.prototype.getMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.setMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool IsWholeMonth = 3;
 * @return {boolean}
 */
proto.income.Details.prototype.getIswholemonth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.setIswholemonth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Amount TotalAmount = 4;
 * @return {?proto.income.Amount}
 */
proto.income.Details.prototype.getTotalamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 4));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Details} returns this
*/
proto.income.Details.prototype.setTotalamount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.clearTotalamount = function() {
  return this.setTotalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Details.prototype.hasTotalamount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 IncomeCount = 5;
 * @return {number}
 */
proto.income.Details.prototype.getIncomecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.setIncomecount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated Transaction Transactions = 6;
 * @return {!Array<!proto.income.Transaction>}
 */
proto.income.Details.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.income.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Transaction, 6));
};


/**
 * @param {!Array<!proto.income.Transaction>} value
 * @return {!proto.income.Details} returns this
*/
proto.income.Details.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.income.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Transaction}
 */
proto.income.Details.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.income.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional IncomeDetails Income = 7;
 * @return {?proto.income.IncomeDetails}
 */
proto.income.Details.prototype.getIncome = function() {
  return /** @type{?proto.income.IncomeDetails} */ (
    jspb.Message.getWrapperField(this, proto.income.IncomeDetails, 7));
};


/**
 * @param {?proto.income.IncomeDetails|undefined} value
 * @return {!proto.income.Details} returns this
*/
proto.income.Details.prototype.setIncome = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.clearIncome = function() {
  return this.setIncome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Details.prototype.hasIncome = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional NonIncomeDetails NonIncome = 8;
 * @return {?proto.income.NonIncomeDetails}
 */
proto.income.Details.prototype.getNonincome = function() {
  return /** @type{?proto.income.NonIncomeDetails} */ (
    jspb.Message.getWrapperField(this, proto.income.NonIncomeDetails, 8));
};


/**
 * @param {?proto.income.NonIncomeDetails|undefined} value
 * @return {!proto.income.Details} returns this
*/
proto.income.Details.prototype.setNonincome = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Details} returns this
 */
proto.income.Details.prototype.clearNonincome = function() {
  return this.setNonincome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Details.prototype.hasNonincome = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Monthly.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Monthly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Monthly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Monthly.toObject = function(includeInstance, msg) {
  var f, obj = {
    averagecount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    averageamount: (f = msg.getAverageamount()) && proto.income.Amount.toObject(includeInstance, f),
    maxamount: (f = msg.getMaxamount()) && proto.income.Amount.toObject(includeInstance, f),
    minamount: (f = msg.getMinamount()) && proto.income.Amount.toObject(includeInstance, f),
    medianamount: (f = msg.getMedianamount()) && proto.income.Amount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Monthly}
 */
proto.income.Monthly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Monthly;
  return proto.income.Monthly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Monthly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Monthly}
 */
proto.income.Monthly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAveragecount(value);
      break;
    case 2:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setAverageamount(value);
      break;
    case 3:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setMaxamount(value);
      break;
    case 4:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setMinamount(value);
      break;
    case 5:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setMedianamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Monthly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Monthly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Monthly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Monthly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAveragecount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAverageamount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getMaxamount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getMinamount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getMedianamount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 AverageCount = 1;
 * @return {number}
 */
proto.income.Monthly.prototype.getAveragecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Monthly} returns this
 */
proto.income.Monthly.prototype.setAveragecount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Amount AverageAmount = 2;
 * @return {?proto.income.Amount}
 */
proto.income.Monthly.prototype.getAverageamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 2));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Monthly} returns this
*/
proto.income.Monthly.prototype.setAverageamount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Monthly} returns this
 */
proto.income.Monthly.prototype.clearAverageamount = function() {
  return this.setAverageamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Monthly.prototype.hasAverageamount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Amount MaxAmount = 3;
 * @return {?proto.income.Amount}
 */
proto.income.Monthly.prototype.getMaxamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 3));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Monthly} returns this
*/
proto.income.Monthly.prototype.setMaxamount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Monthly} returns this
 */
proto.income.Monthly.prototype.clearMaxamount = function() {
  return this.setMaxamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Monthly.prototype.hasMaxamount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Amount MinAmount = 4;
 * @return {?proto.income.Amount}
 */
proto.income.Monthly.prototype.getMinamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 4));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Monthly} returns this
*/
proto.income.Monthly.prototype.setMinamount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Monthly} returns this
 */
proto.income.Monthly.prototype.clearMinamount = function() {
  return this.setMinamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Monthly.prototype.hasMinamount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Amount MedianAmount = 5;
 * @return {?proto.income.Amount}
 */
proto.income.Monthly.prototype.getMedianamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 5));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Monthly} returns this
*/
proto.income.Monthly.prototype.setMedianamount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Monthly} returns this
 */
proto.income.Monthly.prototype.clearMedianamount = function() {
  return this.setMedianamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Monthly.prototype.hasMedianamount = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.IncomeDetails.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.IncomeDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.income.IncomeDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.IncomeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalamount: (f = msg.getTotalamount()) && proto.income.Amount.toObject(includeInstance, f),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    categoriescount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.income.Transaction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.IncomeDetails}
 */
proto.income.IncomeDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.IncomeDetails;
  return proto.income.IncomeDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.IncomeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.IncomeDetails}
 */
proto.income.IncomeDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setTotalamount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategoriescount(value);
      break;
    case 5:
      var value = new proto.income.Transaction;
      reader.readMessage(value,proto.income.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.IncomeDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.IncomeDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.IncomeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalamount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCategoriescount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.income.Transaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Amount TotalAmount = 1;
 * @return {?proto.income.Amount}
 */
proto.income.IncomeDetails.prototype.getTotalamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 1));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.IncomeDetails} returns this
*/
proto.income.IncomeDetails.prototype.setTotalamount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.clearTotalamount = function() {
  return this.setTotalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.IncomeDetails.prototype.hasTotalamount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 Count = 2;
 * @return {number}
 */
proto.income.IncomeDetails.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string Categories = 3;
 * @return {!Array<string>}
 */
proto.income.IncomeDetails.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional int32 CategoriesCount = 4;
 * @return {number}
 */
proto.income.IncomeDetails.prototype.getCategoriescount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.setCategoriescount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Transaction Transactions = 5;
 * @return {!Array<!proto.income.Transaction>}
 */
proto.income.IncomeDetails.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.income.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Transaction, 5));
};


/**
 * @param {!Array<!proto.income.Transaction>} value
 * @return {!proto.income.IncomeDetails} returns this
*/
proto.income.IncomeDetails.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.income.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Transaction}
 */
proto.income.IncomeDetails.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.income.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.IncomeDetails} returns this
 */
proto.income.IncomeDetails.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.IncomeOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.income.IncomeOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.IncomeOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
    monthswithincome: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalamount: (f = msg.getTotalamount()) && proto.income.Amount.toObject(includeInstance, f),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0),
    confidence: jspb.Message.getFieldWithDefault(msg, 4, ""),
    monthly: (f = msg.getMonthly()) && proto.income.Monthly.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.IncomeOverview}
 */
proto.income.IncomeOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.IncomeOverview;
  return proto.income.IncomeOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.IncomeOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.IncomeOverview}
 */
proto.income.IncomeOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthswithincome(value);
      break;
    case 2:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setTotalamount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidence(value);
      break;
    case 5:
      var value = new proto.income.Monthly;
      reader.readMessage(value,proto.income.Monthly.deserializeBinaryFromReader);
      msg.setMonthly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.IncomeOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.IncomeOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.IncomeOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthswithincome();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalamount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getConfidence();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMonthly();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.income.Monthly.serializeBinaryToWriter
    );
  }
};


/**
 * optional string MonthsWithIncome = 1;
 * @return {string}
 */
proto.income.IncomeOverview.prototype.getMonthswithincome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.IncomeOverview} returns this
 */
proto.income.IncomeOverview.prototype.setMonthswithincome = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Amount TotalAmount = 2;
 * @return {?proto.income.Amount}
 */
proto.income.IncomeOverview.prototype.getTotalamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 2));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.IncomeOverview} returns this
*/
proto.income.IncomeOverview.prototype.setTotalamount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.IncomeOverview} returns this
 */
proto.income.IncomeOverview.prototype.clearTotalamount = function() {
  return this.setTotalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.IncomeOverview.prototype.hasTotalamount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 Count = 3;
 * @return {number}
 */
proto.income.IncomeOverview.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.IncomeOverview} returns this
 */
proto.income.IncomeOverview.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Confidence = 4;
 * @return {string}
 */
proto.income.IncomeOverview.prototype.getConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.IncomeOverview} returns this
 */
proto.income.IncomeOverview.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Monthly Monthly = 5;
 * @return {?proto.income.Monthly}
 */
proto.income.IncomeOverview.prototype.getMonthly = function() {
  return /** @type{?proto.income.Monthly} */ (
    jspb.Message.getWrapperField(this, proto.income.Monthly, 5));
};


/**
 * @param {?proto.income.Monthly|undefined} value
 * @return {!proto.income.IncomeOverview} returns this
*/
proto.income.IncomeOverview.prototype.setMonthly = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.IncomeOverview} returns this
 */
proto.income.IncomeOverview.prototype.clearMonthly = function() {
  return this.setMonthly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.IncomeOverview.prototype.hasMonthly = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.NonIncomeDetails.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.NonIncomeDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.income.NonIncomeDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.NonIncomeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.NonIncomeDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalamount: (f = msg.getTotalamount()) && proto.income.Amount.toObject(includeInstance, f),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    categoriescount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.income.Transaction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.NonIncomeDetails}
 */
proto.income.NonIncomeDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.NonIncomeDetails;
  return proto.income.NonIncomeDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.NonIncomeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.NonIncomeDetails}
 */
proto.income.NonIncomeDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setTotalamount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategoriescount(value);
      break;
    case 5:
      var value = new proto.income.Transaction;
      reader.readMessage(value,proto.income.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.NonIncomeDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.NonIncomeDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.NonIncomeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.NonIncomeDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalamount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCategoriescount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.income.Transaction.serializeBinaryToWriter
    );
  }
};


/**
 * optional Amount TotalAmount = 1;
 * @return {?proto.income.Amount}
 */
proto.income.NonIncomeDetails.prototype.getTotalamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 1));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.NonIncomeDetails} returns this
*/
proto.income.NonIncomeDetails.prototype.setTotalamount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.clearTotalamount = function() {
  return this.setTotalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.NonIncomeDetails.prototype.hasTotalamount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 Count = 2;
 * @return {number}
 */
proto.income.NonIncomeDetails.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string Categories = 3;
 * @return {!Array<string>}
 */
proto.income.NonIncomeDetails.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional int32 CategoriesCount = 4;
 * @return {number}
 */
proto.income.NonIncomeDetails.prototype.getCategoriescount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.setCategoriescount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Transaction Transactions = 5;
 * @return {!Array<!proto.income.Transaction>}
 */
proto.income.NonIncomeDetails.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.income.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Transaction, 5));
};


/**
 * @param {!Array<!proto.income.Transaction>} value
 * @return {!proto.income.NonIncomeDetails} returns this
*/
proto.income.NonIncomeDetails.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.income.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Transaction}
 */
proto.income.NonIncomeDetails.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.income.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.NonIncomeDetails} returns this
 */
proto.income.NonIncomeDetails.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.NonIncomeOverview.prototype.toObject = function(opt_includeInstance) {
  return proto.income.NonIncomeOverview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.NonIncomeOverview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.NonIncomeOverview.toObject = function(includeInstance, msg) {
  var f, obj = {
    overalltotalamount: (f = msg.getOveralltotalamount()) && proto.income.Amount.toObject(includeInstance, f),
    overallcount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.NonIncomeOverview}
 */
proto.income.NonIncomeOverview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.NonIncomeOverview;
  return proto.income.NonIncomeOverview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.NonIncomeOverview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.NonIncomeOverview}
 */
proto.income.NonIncomeOverview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setOveralltotalamount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverallcount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.NonIncomeOverview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.NonIncomeOverview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.NonIncomeOverview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.NonIncomeOverview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOveralltotalamount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getOverallcount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional Amount OverallTotalAmount = 1;
 * @return {?proto.income.Amount}
 */
proto.income.NonIncomeOverview.prototype.getOveralltotalamount = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 1));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.NonIncomeOverview} returns this
*/
proto.income.NonIncomeOverview.prototype.setOveralltotalamount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.NonIncomeOverview} returns this
 */
proto.income.NonIncomeOverview.prototype.clearOveralltotalamount = function() {
  return this.setOveralltotalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.NonIncomeOverview.prototype.hasOveralltotalamount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 OverallCount = 2;
 * @return {number}
 */
proto.income.NonIncomeOverview.prototype.getOverallcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.NonIncomeOverview} returns this
 */
proto.income.NonIncomeOverview.prototype.setOverallcount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountnumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nickname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    balance: (f = msg.getBalance()) && proto.income.Amount.toObject(includeInstance, f),
    holdername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    holderaddress: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Account}
 */
proto.income.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Account;
  return proto.income.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Account}
 */
proto.income.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = new proto.income.Amount;
      reader.readMessage(value,proto.income.Amount.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderaddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.income.Amount.serializeBinaryToWriter
    );
  }
  f = message.getHoldername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHolderaddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string AccountNumber = 1;
 * @return {string}
 */
proto.income.Account.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Account} returns this
 */
proto.income.Account.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string NickName = 2;
 * @return {string}
 */
proto.income.Account.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Account} returns this
 */
proto.income.Account.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Amount Balance = 3;
 * @return {?proto.income.Amount}
 */
proto.income.Account.prototype.getBalance = function() {
  return /** @type{?proto.income.Amount} */ (
    jspb.Message.getWrapperField(this, proto.income.Amount, 3));
};


/**
 * @param {?proto.income.Amount|undefined} value
 * @return {!proto.income.Account} returns this
*/
proto.income.Account.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Account} returns this
 */
proto.income.Account.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Account.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string HolderName = 4;
 * @return {string}
 */
proto.income.Account.prototype.getHoldername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Account} returns this
 */
proto.income.Account.prototype.setHoldername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string HolderAddress = 5;
 * @return {string}
 */
proto.income.Account.prototype.getHolderaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Account} returns this
 */
proto.income.Account.prototype.setHolderaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.Income.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Income.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Income.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Income} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Income.toObject = function(includeInstance, msg) {
  var f, obj = {
    overview: (f = msg.getOverview()) && proto.income.Overview.toObject(includeInstance, f),
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.income.Details.toObject, includeInstance),
    accountList: jspb.Message.toObjectList(msg.getAccountList(),
    proto.income.Account.toObject, includeInstance),
    bankcode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    statementid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    incomeid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    error: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Income}
 */
proto.income.Income.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Income;
  return proto.income.Income.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Income} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Income}
 */
proto.income.Income.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Overview;
      reader.readMessage(value,proto.income.Overview.deserializeBinaryFromReader);
      msg.setOverview(value);
      break;
    case 2:
      var value = new proto.income.Details;
      reader.readMessage(value,proto.income.Details.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    case 3:
      var value = new proto.income.Account;
      reader.readMessage(value,proto.income.Account.deserializeBinaryFromReader);
      msg.addAccount(value);
      break;
    case 4:
      var value = /** @type {!proto.income.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIncomeid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 9:
      var value = /** @type {!proto.income.IncomeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Income.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Income.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Income} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Income.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.income.Overview.serializeBinaryToWriter
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.income.Details.serializeBinaryToWriter
    );
  }
  f = message.getAccountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.income.Account.serializeBinaryToWriter
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIncomeid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional Overview Overview = 1;
 * @return {?proto.income.Overview}
 */
proto.income.Income.prototype.getOverview = function() {
  return /** @type{?proto.income.Overview} */ (
    jspb.Message.getWrapperField(this, proto.income.Overview, 1));
};


/**
 * @param {?proto.income.Overview|undefined} value
 * @return {!proto.income.Income} returns this
*/
proto.income.Income.prototype.setOverview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.clearOverview = function() {
  return this.setOverview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Income.prototype.hasOverview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Details Details = 2;
 * @return {!Array<!proto.income.Details>}
 */
proto.income.Income.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.income.Details>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Details, 2));
};


/**
 * @param {!Array<!proto.income.Details>} value
 * @return {!proto.income.Income} returns this
*/
proto.income.Income.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.income.Details=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Details}
 */
proto.income.Income.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.income.Details, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};


/**
 * repeated Account Account = 3;
 * @return {!Array<!proto.income.Account>}
 */
proto.income.Income.prototype.getAccountList = function() {
  return /** @type{!Array<!proto.income.Account>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Account, 3));
};


/**
 * @param {!Array<!proto.income.Account>} value
 * @return {!proto.income.Income} returns this
*/
proto.income.Income.prototype.setAccountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.income.Account=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Account}
 */
proto.income.Income.prototype.addAccount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.income.Account, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.clearAccountList = function() {
  return this.setAccountList([]);
};


/**
 * optional BankCode BankCode = 4;
 * @return {!proto.income.BankCode}
 */
proto.income.Income.prototype.getBankcode = function() {
  return /** @type {!proto.income.BankCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.income.BankCode} value
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp CreatedAt = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.income.Income.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.income.Income} returns this
*/
proto.income.Income.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Income.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string StatementID = 6;
 * @return {string}
 */
proto.income.Income.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string IncomeID = 7;
 * @return {string}
 */
proto.income.Income.prototype.getIncomeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.setIncomeid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Error = 8;
 * @return {string}
 */
proto.income.Income.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional IncomeStatus Status = 9;
 * @return {!proto.income.IncomeStatus}
 */
proto.income.Income.prototype.getStatus = function() {
  return /** @type {!proto.income.IncomeStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.income.IncomeStatus} value
 * @return {!proto.income.Income} returns this
 */
proto.income.Income.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.IncomeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.income.IncomeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.IncomeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.IncomeResponse}
 */
proto.income.IncomeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.IncomeResponse;
  return proto.income.IncomeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.IncomeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.IncomeResponse}
 */
proto.income.IncomeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.IncomeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.IncomeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.IncomeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.IncomeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string StatementID = 1;
 * @return {string}
 */
proto.income.IncomeResponse.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.IncomeResponse} returns this
 */
proto.income.IncomeResponse.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.DownloadIncomeDetailReportRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.income.DownloadIncomeDetailReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.DownloadIncomeDetailReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.DownloadIncomeDetailReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementidsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    retrievalstartdate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    retrievalenddate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fileformat: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.DownloadIncomeDetailReportRequest}
 */
proto.income.DownloadIncomeDetailReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.DownloadIncomeDetailReportRequest;
  return proto.income.DownloadIncomeDetailReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.DownloadIncomeDetailReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.DownloadIncomeDetailReportRequest}
 */
proto.income.DownloadIncomeDetailReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addStatementids(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalstartdate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalenddate(value);
      break;
    case 8:
      var value = /** @type {!proto.income.FileFormat} */ (reader.readEnum());
      msg.setFileformat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.DownloadIncomeDetailReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.DownloadIncomeDetailReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.DownloadIncomeDetailReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getRetrievalstartdate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRetrievalenddate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileformat();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * repeated string StatementIds = 1;
 * @return {!Array<string>}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.getStatementidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.setStatementidsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.addStatementids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.clearStatementidsList = function() {
  return this.setStatementidsList([]);
};


/**
 * optional string RetrievalStartDate = 2;
 * @return {string}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.getRetrievalstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.setRetrievalstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string RetrievalEndDate = 3;
 * @return {string}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.getRetrievalenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.setRetrievalenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional FileFormat FileFormat = 8;
 * @return {!proto.income.FileFormat}
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.getFileformat = function() {
  return /** @type {!proto.income.FileFormat} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.income.FileFormat} value
 * @return {!proto.income.DownloadIncomeDetailReportRequest} returns this
 */
proto.income.DownloadIncomeDetailReportRequest.prototype.setFileformat = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.income.DownloadIncomeDetailReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.DownloadIncomeDetailReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.DownloadIncomeDetailReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: msg.getData_asB64(),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0),
    downloadid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.DownloadIncomeDetailReportResponse}
 */
proto.income.DownloadIncomeDetailReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.DownloadIncomeDetailReportResponse;
  return proto.income.DownloadIncomeDetailReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.DownloadIncomeDetailReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.DownloadIncomeDetailReportResponse}
 */
proto.income.DownloadIncomeDetailReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.DownloadIncomeDetailReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.DownloadIncomeDetailReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.DownloadIncomeDetailReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDownloadid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string Filename = 1;
 * @return {string}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.DownloadIncomeDetailReportResponse} returns this
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.income.DownloadIncomeDetailReportResponse} returns this
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional int32 Size = 3;
 * @return {number}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.DownloadIncomeDetailReportResponse} returns this
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string DownloadID = 4;
 * @return {string}
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.getDownloadid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.DownloadIncomeDetailReportResponse} returns this
 */
proto.income.DownloadIncomeDetailReportResponse.prototype.setDownloadid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.RetrieveIncomeListRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.RetrieveIncomeListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.income.RetrieveIncomeListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.RetrieveIncomeListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementidsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    pagesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderby: jspb.Message.getFieldWithDefault(msg, 3, 0),
    retrievalstartdate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    retrievalenddate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pagetoken: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.RetrieveIncomeListRequest}
 */
proto.income.RetrieveIncomeListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.RetrieveIncomeListRequest;
  return proto.income.RetrieveIncomeListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.RetrieveIncomeListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.RetrieveIncomeListRequest}
 */
proto.income.RetrieveIncomeListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addStatementids(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 3:
      var value = /** @type {!proto.income.OrderBy} */ (reader.readEnum());
      msg.setOrderby(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalstartdate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalenddate(value);
      break;
    case 6:
      var value = /** @type {!proto.income.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPagetoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.RetrieveIncomeListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.RetrieveIncomeListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.RetrieveIncomeListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOrderby();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRetrievalstartdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRetrievalenddate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPagetoken();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * repeated string StatementIds = 1;
 * @return {!Array<string>}
 */
proto.income.RetrieveIncomeListRequest.prototype.getStatementidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setStatementidsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.addStatementids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.clearStatementidsList = function() {
  return this.setStatementidsList([]);
};


/**
 * optional int32 PageSize = 2;
 * @return {number}
 */
proto.income.RetrieveIncomeListRequest.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional OrderBy OrderBy = 3;
 * @return {!proto.income.OrderBy}
 */
proto.income.RetrieveIncomeListRequest.prototype.getOrderby = function() {
  return /** @type {!proto.income.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.income.OrderBy} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setOrderby = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string RetrievalStartDate = 4;
 * @return {string}
 */
proto.income.RetrieveIncomeListRequest.prototype.getRetrievalstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setRetrievalstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string RetrievalEndDate = 5;
 * @return {string}
 */
proto.income.RetrieveIncomeListRequest.prototype.getRetrievalenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setRetrievalenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional BankCode BankCode = 6;
 * @return {!proto.income.BankCode}
 */
proto.income.RetrieveIncomeListRequest.prototype.getBankcode = function() {
  return /** @type {!proto.income.BankCode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.income.BankCode} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string PageToken = 7;
 * @return {string}
 */
proto.income.RetrieveIncomeListRequest.prototype.getPagetoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListRequest} returns this
 */
proto.income.RetrieveIncomeListRequest.prototype.setPagetoken = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.RetrieveIncomeListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.RetrieveIncomeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.income.RetrieveIncomeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.RetrieveIncomeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    incomesList: jspb.Message.toObjectList(msg.getIncomesList(),
    proto.income.Income.toObject, includeInstance),
    nextpagetoken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalcount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    previouspagetoken: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.RetrieveIncomeListResponse}
 */
proto.income.RetrieveIncomeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.RetrieveIncomeListResponse;
  return proto.income.RetrieveIncomeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.RetrieveIncomeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.RetrieveIncomeListResponse}
 */
proto.income.RetrieveIncomeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Income;
      reader.readMessage(value,proto.income.Income.deserializeBinaryFromReader);
      msg.addIncomes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextpagetoken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcount(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviouspagetoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.RetrieveIncomeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.RetrieveIncomeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.RetrieveIncomeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncomesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.income.Income.serializeBinaryToWriter
    );
  }
  f = message.getNextpagetoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalcount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPreviouspagetoken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * repeated Income Incomes = 1;
 * @return {!Array<!proto.income.Income>}
 */
proto.income.RetrieveIncomeListResponse.prototype.getIncomesList = function() {
  return /** @type{!Array<!proto.income.Income>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Income, 1));
};


/**
 * @param {!Array<!proto.income.Income>} value
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
*/
proto.income.RetrieveIncomeListResponse.prototype.setIncomesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.income.Income=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Income}
 */
proto.income.RetrieveIncomeListResponse.prototype.addIncomes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.income.Income, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
 */
proto.income.RetrieveIncomeListResponse.prototype.clearIncomesList = function() {
  return this.setIncomesList([]);
};


/**
 * optional string NextPageToken = 2;
 * @return {string}
 */
proto.income.RetrieveIncomeListResponse.prototype.getNextpagetoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
 */
proto.income.RetrieveIncomeListResponse.prototype.setNextpagetoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Message = 3;
 * @return {string}
 */
proto.income.RetrieveIncomeListResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
 */
proto.income.RetrieveIncomeListResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 TotalCount = 4;
 * @return {number}
 */
proto.income.RetrieveIncomeListResponse.prototype.getTotalcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
 */
proto.income.RetrieveIncomeListResponse.prototype.setTotalcount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string PreviousPageToken = 5;
 * @return {string}
 */
proto.income.RetrieveIncomeListResponse.prototype.getPreviouspagetoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeListResponse} returns this
 */
proto.income.RetrieveIncomeListResponse.prototype.setPreviouspagetoken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.RetrieveIncomeDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.income.RetrieveIncomeDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.RetrieveIncomeDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    skipdetails: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.RetrieveIncomeDetailRequest}
 */
proto.income.RetrieveIncomeDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.RetrieveIncomeDetailRequest;
  return proto.income.RetrieveIncomeDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.RetrieveIncomeDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.RetrieveIncomeDetailRequest}
 */
proto.income.RetrieveIncomeDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipdetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.RetrieveIncomeDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.RetrieveIncomeDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.RetrieveIncomeDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSkipdetails();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string StatementID = 1;
 * @return {string}
 */
proto.income.RetrieveIncomeDetailRequest.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeDetailRequest} returns this
 */
proto.income.RetrieveIncomeDetailRequest.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool SkipDetails = 2;
 * @return {boolean}
 */
proto.income.RetrieveIncomeDetailRequest.prototype.getSkipdetails = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.income.RetrieveIncomeDetailRequest} returns this
 */
proto.income.RetrieveIncomeDetailRequest.prototype.setSkipdetails = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.income.RetrieveIncomeDetailResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.income.RetrieveIncomeDetailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.RetrieveIncomeDetailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeDetailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    overview: (f = msg.getOverview()) && proto.income.Overview.toObject(includeInstance, f),
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.income.Details.toObject, includeInstance),
    accountList: jspb.Message.toObjectList(msg.getAccountList(),
    proto.income.Account.toObject, includeInstance),
    bankcode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    statementid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    incomeid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    error: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    iswhitelisted: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.RetrieveIncomeDetailResponse}
 */
proto.income.RetrieveIncomeDetailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.RetrieveIncomeDetailResponse;
  return proto.income.RetrieveIncomeDetailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.RetrieveIncomeDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.RetrieveIncomeDetailResponse}
 */
proto.income.RetrieveIncomeDetailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.income.Overview;
      reader.readMessage(value,proto.income.Overview.deserializeBinaryFromReader);
      msg.setOverview(value);
      break;
    case 2:
      var value = new proto.income.Details;
      reader.readMessage(value,proto.income.Details.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    case 3:
      var value = new proto.income.Account;
      reader.readMessage(value,proto.income.Account.deserializeBinaryFromReader);
      msg.addAccount(value);
      break;
    case 4:
      var value = /** @type {!proto.income.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIncomeid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 9:
      var value = /** @type {!proto.income.IncomeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIswhitelisted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.RetrieveIncomeDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.RetrieveIncomeDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.RetrieveIncomeDetailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOverview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.income.Overview.serializeBinaryToWriter
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.income.Details.serializeBinaryToWriter
    );
  }
  f = message.getAccountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.income.Account.serializeBinaryToWriter
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIncomeid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getIswhitelisted();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional Overview Overview = 1;
 * @return {?proto.income.Overview}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getOverview = function() {
  return /** @type{?proto.income.Overview} */ (
    jspb.Message.getWrapperField(this, proto.income.Overview, 1));
};


/**
 * @param {?proto.income.Overview|undefined} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
*/
proto.income.RetrieveIncomeDetailResponse.prototype.setOverview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.clearOverview = function() {
  return this.setOverview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.hasOverview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Details Details = 2;
 * @return {!Array<!proto.income.Details>}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.income.Details>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Details, 2));
};


/**
 * @param {!Array<!proto.income.Details>} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
*/
proto.income.RetrieveIncomeDetailResponse.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.income.Details=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Details}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.income.Details, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};


/**
 * repeated Account Account = 3;
 * @return {!Array<!proto.income.Account>}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getAccountList = function() {
  return /** @type{!Array<!proto.income.Account>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.income.Account, 3));
};


/**
 * @param {!Array<!proto.income.Account>} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
*/
proto.income.RetrieveIncomeDetailResponse.prototype.setAccountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.income.Account=} opt_value
 * @param {number=} opt_index
 * @return {!proto.income.Account}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.addAccount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.income.Account, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.clearAccountList = function() {
  return this.setAccountList([]);
};


/**
 * optional BankCode BankCode = 4;
 * @return {!proto.income.BankCode}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getBankcode = function() {
  return /** @type {!proto.income.BankCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.income.BankCode} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp CreatedAt = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
*/
proto.income.RetrieveIncomeDetailResponse.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string StatementID = 6;
 * @return {string}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string IncomeID = 7;
 * @return {string}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getIncomeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setIncomeid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Error = 8;
 * @return {string}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional IncomeStatus Status = 9;
 * @return {!proto.income.IncomeStatus}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getStatus = function() {
  return /** @type {!proto.income.IncomeStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.income.IncomeStatus} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional bool IsWhitelisted = 10;
 * @return {boolean}
 */
proto.income.RetrieveIncomeDetailResponse.prototype.getIswhitelisted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.income.RetrieveIncomeDetailResponse} returns this
 */
proto.income.RetrieveIncomeDetailResponse.prototype.setIswhitelisted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Decimal.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Decimal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Decimal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Decimal.toObject = function(includeInstance, msg) {
  var f, obj = {
    places: jspb.Message.getFieldWithDefault(msg, 1, 0),
    num: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Decimal}
 */
proto.income.Decimal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Decimal;
  return proto.income.Decimal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Decimal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Decimal}
 */
proto.income.Decimal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlaces(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Decimal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Decimal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Decimal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Decimal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaces();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 Places = 1;
 * @return {number}
 */
proto.income.Decimal.prototype.getPlaces = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.income.Decimal} returns this
 */
proto.income.Decimal.prototype.setPlaces = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Num = 2;
 * @return {string}
 */
proto.income.Decimal.prototype.getNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Decimal} returns this
 */
proto.income.Decimal.prototype.setNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.income.Amount.prototype.toObject = function(opt_includeInstance) {
  return proto.income.Amount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.income.Amount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Amount.toObject = function(includeInstance, msg) {
  var f, obj = {
    cur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    num: jspb.Message.getFieldWithDefault(msg, 2, ""),
    decimal: (f = msg.getDecimal()) && proto.income.Decimal.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.income.Amount}
 */
proto.income.Amount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.income.Amount;
  return proto.income.Amount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.income.Amount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.income.Amount}
 */
proto.income.Amount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.income.CurrencyISO4217} */ (reader.readEnum());
      msg.setCur(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNum(value);
      break;
    case 3:
      var value = new proto.income.Decimal;
      reader.readMessage(value,proto.income.Decimal.deserializeBinaryFromReader);
      msg.setDecimal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.income.Amount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.income.Amount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.income.Amount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.income.Amount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCur();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDecimal();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.income.Decimal.serializeBinaryToWriter
    );
  }
};


/**
 * optional CurrencyISO4217 Cur = 1;
 * @return {!proto.income.CurrencyISO4217}
 */
proto.income.Amount.prototype.getCur = function() {
  return /** @type {!proto.income.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.income.CurrencyISO4217} value
 * @return {!proto.income.Amount} returns this
 */
proto.income.Amount.prototype.setCur = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Num = 2;
 * @return {string}
 */
proto.income.Amount.prototype.getNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.income.Amount} returns this
 */
proto.income.Amount.prototype.setNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Decimal Decimal = 3;
 * @return {?proto.income.Decimal}
 */
proto.income.Amount.prototype.getDecimal = function() {
  return /** @type{?proto.income.Decimal} */ (
    jspb.Message.getWrapperField(this, proto.income.Decimal, 3));
};


/**
 * @param {?proto.income.Decimal|undefined} value
 * @return {!proto.income.Amount} returns this
*/
proto.income.Amount.prototype.setDecimal = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.income.Amount} returns this
 */
proto.income.Amount.prototype.clearDecimal = function() {
  return this.setDecimal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.income.Amount.prototype.hasDecimal = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.income.IncomeStatus = {
  UNKNOWN_INCOMESTATUS: 0,
  COMPLETED: 1,
  FAILED: 2
};

/**
 * @enum {number}
 */
proto.income.OrderBy = {
  DATE_DESCENDING: 0,
  DATE_ASCENDING: 1
};

/**
 * @enum {number}
 */
proto.income.FileFormat = {
  UNKNOWN_FILEFORMAT: 0,
  CSV: 1
};

/**
 * @enum {number}
 */
proto.income.BankCode = {
  UNKNOWN_BANK: 0,
  MANDIRI_PERSONAL: 257,
  BCA_PERSONAL: 258,
  BNI_PERSONAL: 259,
  BRI_PERSONAL: 260,
  BCA_CORPORATE: 514,
  DUMMY_BANK_PERSONAL: 261,
  BDO_PERSONAL: 262,
  BPI_PERSONAL: 263,
  KASIKORNBANK_PERSONAL: 405,
  PNB_PERSONAL: 406,
  UNIONBANK_PERSONAL: 407,
  UNIONBANK_CORPORATE: 410,
  METROBANK_PERSONAL: 408,
  RCBC_PERSONAL: 409,
  DANAMON_PERSONAL: 411,
  GOPAY_PERSONAL: 412,
  TOKOPEDIA_PERSONAL: 413,
  TOKOPEDIA_CORPORATE: 414,
  MANDIRI_CORPORATE: 415,
  BNI_CORPORATE: 559,
  PERMATA_CORPORATE: 416,
  OVO_PERSONAL: 417,
  OCBC_PERSONAL: 418,
  SHOPEE_CORPORATE: 419,
  JAGO_PERSONAL: 420,
  SHOPEE_PERSONAL: 421
};

/**
 * @enum {number}
 */
proto.income.CurrencyISO4217 = {
  UNKNOWN_CURRENCY: 0,
  AFN: 1,
  EUR: 2,
  ALL: 3,
  DZD: 4,
  USD: 5,
  AOA: 6,
  XCD: 7,
  ARS: 8,
  AMD: 9,
  AWG: 10,
  AUD: 11,
  AZN: 12,
  BSD: 13,
  BHD: 14,
  BDT: 15,
  BYR: 16,
  BZD: 17,
  XOF: 18,
  BMD: 19,
  BTN: 20,
  BOV: 21,
  BAM: 22,
  BWP: 23,
  NOK: 24,
  BRL: 25,
  SGD: 26,
  BGN: 27,
  BIF: 28,
  KHR: 29,
  XAF: 30,
  CAD: 31,
  CVE: 32,
  KYD: 33,
  CLP: 34,
  CNY: 35,
  COP: 36,
  KMF: 37,
  CDF: 38,
  NZD: 39,
  CRC: 40,
  HRK: 41,
  CUC: 42,
  CZK: 43,
  DKK: 44,
  DJF: 45,
  DOP: 46,
  EGP: 47,
  ERN: 48,
  ETB: 49,
  FKP: 50,
  FJD: 51,
  XPF: 52,
  GMD: 53,
  GEL: 54,
  GHS: 55,
  GIP: 56,
  GTQ: 57,
  GBP: 58,
  GNF: 59,
  GYD: 60,
  HNL: 61,
  HKD: 62,
  HUF: 63,
  ISK: 64,
  INR: 65,
  IDR: 66,
  IRR: 67,
  IQD: 68,
  IMP: 69,
  ILS: 70,
  JMD: 71,
  JPY: 72,
  JEP: 73,
  JOD: 74,
  KZT: 75,
  KES: 76,
  KPW: 77,
  KRW: 78,
  KWD: 79,
  KGS: 80,
  LAK: 81,
  LBP: 82,
  LSL: 83,
  LRD: 84,
  LYD: 85,
  CHF: 86,
  MKD: 87,
  MGA: 88,
  MWK: 89,
  MYR: 90,
  MVR: 91,
  MRO: 92,
  MUR: 93,
  MXN: 94,
  MDL: 95,
  MNT: 96,
  MAD: 97,
  MZN: 98,
  MMK: 99,
  NAD: 100,
  NPR: 101,
  ANG: 102,
  NIO: 103,
  NGN: 104,
  OMR: 105,
  PKR: 106,
  PGK: 107,
  PYG: 108,
  PEN: 109,
  PHP: 110,
  PLN: 111,
  QAR: 112,
  RON: 113,
  RUB: 114,
  RWF: 115,
  WST: 116,
  STD: 117,
  SAR: 118,
  RSD: 119,
  SCR: 120,
  SLL: 121,
  SBD: 122,
  SOS: 123,
  ZAR: 124,
  SSP: 125,
  LKR: 126,
  SHP: 127,
  SDG: 128,
  SRD: 129,
  SZL: 130,
  SEK: 131,
  SYP: 132,
  TWD: 133,
  TJS: 134,
  TZS: 135,
  THB: 136,
  TOP: 137,
  TTD: 138,
  TND: 139,
  TRY: 140,
  TMT: 141,
  UGX: 142,
  UAH: 143,
  ARE: 144,
  UYU: 145,
  UZS: 146,
  VUV: 147,
  VEF: 148,
  VND: 149,
  YER: 150,
  ZRN: 151,
  ZMW: 152
};

goog.object.extend(exports, proto.income);
